import Vue from 'vue'
import Router from 'vue-router'
import VModal from 'vue-js-modal'
import VeeValidate from 'vee-validate'


Vue.use(Router)
Vue.use(VModal, { dialog: true, dynamic: true, })
Vue.use(VeeValidate, {
  classes: true
})


export default new Router({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
    },
  ]
})
